import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';

@Injectable({
	providedIn: 'root',
})
export class MyAssetConfigurationGeneralService {
	private readonly http = inject(HttpClient);
	private readonly authLoginService = inject(AuthLoginService);

	private getHeaders(): HttpHeaders {
		return new HttpHeaders({
			Authorization: 'Bearer ' + this.authLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
	}

	/**
	 * Busca as configurações gerais do MyAsset.
	 */
	getSettings(): Observable<any> {
		const url = `${environment.baseApiUrl}myasset/settings`;
		return this.http.get<any>(url, { headers: this.getHeaders() });
	}

	/**
	 * Salva/Atualiza as configurações do MyAsset.
	 * @param settings Configurações a serem salvas
	 */
	saveSettings(settings: any): Observable<any> {
		const url = `${environment.baseApiUrl}myasset/settings`;
		return this.http.post<any>(url, settings, { headers: this.getHeaders() });
	}
}
